import Layers from "slotworks/graphics/layers/layers";
import ButtonElement, { ButtonEvent } from "slotworks/graphics/elements/button-element";
import { Container } from "pixi.js";
import { CenterPivot, PIXIElement } from "slotworks/graphics/pixi/group";
import Point from "slotworks/utils/geom/point";
import HarleyComponents from "components/components";
import deviceInfo from "slotworks/utils/device-info";

export default class BonusBuyButtonComponent {

    public static HIDE_TIME = 400;

    private layer: Layers;
    private buyButton: ButtonElement;
    private container: Container;

    private started: boolean = false;
    private enabled: boolean = false;
    private hidden: boolean = false;

    private position: Point;

    public start() {
        this.started = true;
        this.enabled = true;
        this.hidden = false;

        this.layer = Layers.Custom.get("BonusBuyButton");
        this.layer.show();
        this.layer.setScene("bonusbuy").execute();

        if (deviceInfo.isDesktop) {
            deviceInfo.onLayoutChange.add(() => setTimeout(() => this.init(), 10));
        }

        this.init();
    }

    public setEnabled(enable: boolean) {
        this.enabled = enable;

        if (this.buyButton) {
            this.buyButton.setEnabled(this.enabled);
        }
    }

    public isStarted() {
        return this.started;
    }

    public show() {
        if (this.started && this.hidden) {
            this.layer.show();
            this.layer.container.alpha = 1;
            this.hidden = false;
        }
    }

    public hide() {
        if (this.started && !this.hidden) {
            this.layer.hide();
            this.hidden = true;
        }
    }

    private init = () => {
        this.setButton();

        this.setEnabled(this.enabled);

        this.container = CenterPivot([...this.layer.container.children] as PIXIElement[], "bonusbuy_container", new Point(0.5, 0.7));
        this.container.visible = !this.hidden;

        this.position = new Point(this.container.x, this.container.y);
    }

    private setButton() {
        if (this.buyButton) {
            this.buyButton.off(ButtonEvent.POINTER_DOWN, this.showBuyPrompt);
            this.buyButton = null;
        }

        this.buyButton = this.layer.getButton("bonusbuy");
        this.buyButton.on(ButtonEvent.POINTER_DOWN, this.showBuyPrompt);
        this.buyButton.setEnabled(this.enabled);
    }

    private showBuyPrompt = () => {
        if (this.started && this.enabled) {
            this.hide();
            HarleyComponents.bonusBuy.show().then((res) => {
                if (!res) {
                    this.setEnabled(true);
                    this.show();
                }
            });
        }
    }
}